<div class="card">
  <div class="card-header">Summary</div>
  <div class="card-body">
    @if (summaryData.length) {
      <table class="table m-0">
        <thead>
          <tr>
            <td></td>
            @for (col of summaryData[0].data; track col[0]) {
              <td>{{ col[0] }}</td>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of summaryData; track row.label) {
            <tr>
              <td>{{ row.label }}</td>
              @for (col of row.data; track col[0]) {
                <td>{{ col[1] * 100 | number: "1.0-2" }}%</td>
              }
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
